import { render, staticRenderFns } from "./serviceDescription.vue?vue&type=template&id=0d691970&scoped=true&"
import script from "./serviceDescription.vue?vue&type=script&lang=js&"
export * from "./serviceDescription.vue?vue&type=script&lang=js&"
import style0 from "./serviceDescription.vue?vue&type=style&index=0&id=0d691970&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d691970",
  null
  
)

export default component.exports